import React from 'react';
import '../assets/css/Services.css'; 
import web_development from '../assets/images/gif/web_development.gif';  
import cloud_solutions from '../assets/images/gif/cloud_solutions.gif';  
import consulting from '../assets/images/gif/consulting.gif';  
import cybersecurity from '../assets/images/gif/cybersecurity.gif';  
import digital_marketing from '../assets/images/gif/digital_marketing.gif';  
import mobile_app_development from '../assets/images/gif/mobile_app.gif';  
import software_development from '../assets/images/gif/software_development.gif';  
import ux_design from '../assets/images/gif/ux_design.gif';  
import started from '../assets/images/started.svg';  



const Services = () => {
  return (
    <div id="services">
      <section className="services">
        <h2>Our Services</h2>
        <p>We offer a range of services that can help you grow and succeed in the digital world.</p>

        <div className="services-container">
          <div className="service-card">
            <img src={web_development} alt="Web Development"/>
            <h3>Web Development</h3>
            <p>Build responsive and user-friendly websites to enhance your online presence.</p>
          </div>

          <div className="service-card">
            <img src={mobile_app_development} alt="Mobile App Development"/>
            <h3>Mobile App Development</h3>
            <p>Create mobile applications that offer seamless user experiences across platforms.</p>
          </div>

          <div className="service-card">
            <img src={ux_design} alt="UI/UX Design"/>
            <h3>UI/UX Design</h3>
            <p>Design beautiful and intuitive user interfaces to keep users engaged.</p>
          </div>

          <div className="service-card">
            <img src={digital_marketing} alt="Digital Marketing"/>
            <h3>Digital Marketing</h3>
            <p>Implement strategies to increase your online visibility and attract more customers.</p>
          </div>

          <div className="service-card">
            <img src={cloud_solutions} alt="Cloud Solutions"/>
            <h3>Cloud Solutions</h3>
            <p>Leverage the power of cloud technology to streamline operations and scale effortlessly.</p>
          </div>

          <div className="service-card">
            <img src={software_development} alt="Software Development"/>
            <h3>Software Development</h3>
            <p>Custom software solutions designed to meet your specific business needs.</p>
          </div>

          <div className="service-card">
            <img src={consulting} alt="Consulting"/>
            <h3>Consulting</h3>
            <p>Get expert advice and strategies to drive business transformation and growth.</p>
          </div>

          <div className="service-card">
            <img src={cybersecurity} alt="SEO Optimization"/>
            <h3>Cybersecurity</h3>
            <p>Offer security solutions including audits, vulnerability assessments, and risk management.</p>
          </div>
        </div>
      </section>

      <section className="creative-section">
        <div className="overlay">
          <h2 className="fade-in">Ready to Take the Next Step?</h2>
          <p className="fade-in">Let us help you bring your ideas to life with innovative solutions and cutting-edge technology.</p>
          <br></br>
          <br></br>
          <img src={started} alt="Creative Image" className="responsive-image"/>
          <a href="mailto:info@company.com?subject=Inquiry">
            <button className="cta-button">Get Started</button>
          </a>
        </div>
    </section>

  </div>
  );
};

export default Services;

